import React from 'react';

const AboutUs = () => {
  return (
    <section id="about" className="py-20 bg-gray-100 text-gray-800 mt-20">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-10">Sobre Nós</h2>
        <div className="flex flex-col md:flex-row md:space-x-6">
          <div className="md:w-1/2">
            <p className="text-lg mb-4">
              Fundada em 2019, a Uniconn Sistemas surgiu da necessidade de criar sistemas únicos e eficientes. Apesar de jovem, a Uniconn foi fundada por veteranos da indústria de tecnologia, com anos de experiência no desenvolvimento de software e soluções tecnológicas inovadoras.
            </p>
            <p className="text-lg mb-4">
              Desde o início, nosso foco sempre foi a excelência. Trabalhamos arduamente para fornecer sistemas de alta qualidade que atendam às necessidades específicas de nossos clientes. Cada projeto é tratado com dedicação e compromisso, garantindo resultados excepcionais.
            </p>
            <p className="text-lg mb-4">
              Na Uniconn Sistemas, acreditamos na inovação constante. Nossa equipe está sempre em busca das melhores tecnologias e práticas para implementar em nossos projetos. Isso nos permite oferecer soluções de ponta que ajudam nossos clientes a se destacarem no mercado.
            </p>
            <p className="text-lg mb-4">
              Além disso, nossa abordagem personalizada nos permite entender profundamente as necessidades de cada cliente e entregar soluções que realmente fazem a diferença. Estamos comprometidos com o sucesso de nossos clientes e trabalhamos como parceiros estratégicos para alcançar os melhores resultados.
            </p>
          </div>
          <div className="md:w-1/2 mt-6 md:mt-0">
            <img src="https://images.pexels.com/photos/3183197/pexels-photo-3183197.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Nossa equipe" className="w-full h-auto rounded-lg shadow-lg"/>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
